import { BrandGroupConfig } from '../types/apiConfig';
import { useSelector } from 'react-redux';
import { brandGroupConfigSelector } from '../redux/reducers/brandGroupConfigReducer';
import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { RegistrationFlowParams } from './useRegistrationFlowConfiguration';

export function useBrandGroupConfig() {
  const [searchParams] = useSearchParams();
  const allBrandGroupConfig: BrandGroupConfig[] = useSelector(brandGroupConfigSelector);

  const getBrandGroupConfigFromBrandId = useCallback(
    (brandId: string | null) => {
      return allBrandGroupConfig.find(({ brands }) =>
        brands.some((brand) => brand.id.toLowerCase() === brandId?.toLowerCase())
      );
    },
    [allBrandGroupConfig]
  );

  const brandGroupConfig = useMemo(() => {
    const rawParams = Object.fromEntries(searchParams.entries());
    return getBrandGroupConfigFromBrandId(rawParams[RegistrationFlowParams.BRAND] ?? null);
  }, [getBrandGroupConfigFromBrandId, searchParams]);

  const getBrandConfigFromBrandId = useCallback(
    (brandId: string | null) => {
      const brandGroup = getBrandGroupConfigFromBrandId(brandId);
      return (brandGroup?.brands || []).find((b) => b.id.toLowerCase() === brandId?.toLowerCase());
    },
    [getBrandGroupConfigFromBrandId]
  );

  const brandConfig = useMemo(() => {
    const rawParams = Object.fromEntries(searchParams.entries());
    return getBrandConfigFromBrandId(rawParams[RegistrationFlowParams.BRAND] ?? null);
  }, [getBrandConfigFromBrandId, searchParams]);

  return {
    getBrandGroupConfigFromBrandId,
    getBrandConfigFromBrandId,
    brandGroupConfig,
    brandConfig,
  };
}
